/**
 * Section_Service.ts
 * CRUD + lifecycle for hospitality sections (adapter /v1/sections).
 */

import { apiClient } from '../../api/axiosInstance';
import { Hosp_Sections_Url, Hosp_Section_Url } from '../../api/endpoints';
import type { Section, CreateSectionInput, UpdateSectionInput } from '../../schemas/config/section';

export const getSections = async (locationId?: string): Promise<Section[]> => {
  const { data } = await apiClient.get<Section[]>(Hosp_Sections_Url, {
    params: locationId ? { locationId } : undefined,
  });
  return data;
};

export const createSection = async (input: CreateSectionInput): Promise<Section> => {
  const { data } = await apiClient.post<Section>(Hosp_Sections_Url, input);
  return data;
};

export const updateSection = async (id: string, input: UpdateSectionInput): Promise<Section> => {
  const { data } = await apiClient.patch<Section>(Hosp_Section_Url(id), input);
  return data;
};

export const deactivateSection = async (id: string): Promise<void> => {
  await apiClient.delete(Hosp_Section_Url(id));
};
